import { render, staticRenderFns } from "./RemoveUnsubscribed.vue?vue&type=template&id=d2fbf2de&"
import script from "./RemoveUnsubscribed.vue?vue&type=script&lang=js&"
export * from "./RemoveUnsubscribed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports